import { DocAssistRenderParams, RenderParams } from './types';

export const renderAppt = (params: RenderParams): void => {
    window.renderAppt?.(params);
};

export const renderNewAppt = (params: RenderParams): void => {
    window.renderNewAppt?.(params);
};

export const renderBillingDashboard = (params: RenderParams): void => {
    window.billingDashboard?.(params);
};

export const renderReceiptConfig = (params: RenderParams): void => {
    window.receiptCustomisation?.(params);
};

export const renderToolPlan = (params: RenderParams): void => {
    window.toolPlanPaymentPersuasion?.(params);
};

export const renderManageTreatmentPackages = (params: RenderParams): void => {
    window.manageTreatmentPackagesScreen?.(params);
};

export const renderCurrentTreatment = (params: RenderParams): void => {
    window.currentTreatmentScreen?.(params);
};

export const renderGlobalSearchApptComponent = (params: {
    containerId: string;
    ptOid: string | undefined;
    clinicId: string | undefined;
}): void => {
    window.renderAppointmentWidget?.(params);
};

export const renderManageServices = (params: RenderParams): void => {
    window.manageServicesScreen?.(params);
};

export const renderAbhaDoctool = (params: RenderParams): void => {
    window.renderAbhaDoctool?.(params);
};
export const renderAbhaLinkDoctool = (params: RenderParams): void => {
    window.renderAbhaLinkDoctool?.(params);
};

export const renderAppointmentConfig = (params: RenderParams): void => {
    window.appointmentConfigsScreen?.(params);
};

export const renderDocAssist = (params: DocAssistRenderParams): void => {
    window.docAssist?.(params);
};

export const isApp = () => {
    return !!window?.webkit || !!window?.Eka;
};
